import React from 'react';
import SpeakerCard from '../components/speakers/SpeakerCard';
import './SpeakersPage.css';

import ProfNunoSilvestre from '../assets/keynoteSpeakers/ProfNunoSilvestre.png';
import ProfXiaoLinZhao from '../assets/keynoteSpeakers/ProfXiao-LinZHAO.png';
import ProfYingZhou from '../assets/keynoteSpeakers/ProfYingZhou.jpg';
import ProfManuelLRomero from '../assets/keynoteSpeakers/ProfManuelLRomero.jpeg';
import ProfXinzhengLu from '../assets/keynoteSpeakers/ProfXinzhengLu.jpg';
// import ProfRichardLiew from '../assets/keynoteSpeakers/ProfRichardLiew.jpg';
import ProfBenYoung from '../assets/keynoteSpeakers/ProfBenYoung.png';
import ProfTuanNgo from '../assets/keynoteSpeakers/ProfTuanNgo.jpeg';
import ProfSarahYixiaZhang from '../assets/keynoteSpeakers/ProfSarahZhang.jpg';
// import ProfHengHu from '../assets/keynoteSpeakers/ProfHengHu.jpg';
import ProfHalilSezen from '../assets/keynoteSpeakers/ProfHalilSezen.jpg';
import ProfVivianTam from '../assets/keynoteSpeakers/ProfVivianTam.jpg';


const keynoteSpeakers = [
  {
    name: 'Prof Nuno Silvestre',
    affiliation: 'University of Lisbon',
    bio: 'Professor at the Department of Mechanical Engineering, University of Lisbon, specializing in lightweight structures and nanomaterials',
    photo: ProfNunoSilvestre,
    affiliationUrl: 'https://fenix.tecnico.ulisboa.pt/homepage/ist13506'
  },
  {
    name: 'Prof Xiao-Lin ZHAO',
    affiliation: 'The Hong Kong Polytechnic University (PolyU)',
    bio: 'Professor, specializing in high-performance sustainable materials and hybrid structural systems in civil engineering',
    photo: ProfXiaoLinZhao,
    affiliationUrl: 'https://www.polyu.edu.hk/cee/people/academic-staff/prof-xiao-lin-zhao/'
  },
  {
    name: 'Prof Ying Zhou',
    affiliation: 'Tongji University',
    bio: 'Professor & Chair of the Department of Disaster Mitigation for Structures at Tongji University, specializing in seismic design and earthquake-resilient structures',
    photo: ProfYingZhou,
    affiliationUrl: 'https://ddms.tongji.edu.cn/ddmsen/1a/99/c35386a137881/page.htm'
  },
  {
    name: 'Prof Manuel L. Romero',
    affiliation: 'Universitat Politècnica de València',
    bio: 'Professor and Director of the Department of Continuum Mechanics and Theory of Structures at the Universitat Politècnica de València, and former Head of the research institute ICITECH, specializing in numerical and experimental analysis of steel, concrete, timber and hybrid composite structures at room temperature and in fire. Associate Editor of Engineering Structures, with more than 150 papers in international journals and conferences. His current research focuses on innovative materials for safe and sustainable structures, including high-strength steels, geopolymer and ultra-high strength concretes, and timber',
    photo: ProfManuelLRomero,
    affiliationUrl: 'https://scholar.google.com/citations?user=Z74NC10AAAAJ&hl=es'
  },
  {
    name: 'Prof Xinzheng Lu',
    affiliation: 'Tsinghua University',
    bio: 'Professor & Head of the Institute of Disaster Prevention and Mitigation at Tsinghua University, specializing in structural engineering and urban disaster resilience',
    photo: ProfXinzhengLu,
    affiliationUrl: 'https://www.civil.tsinghua.edu.cn/ceen/info/1063/1221.htm'
  },
  // {
  //   name: 'Prof Richard Liew',
  //   affiliation: 'National University of Singapore',
  //   bio: 'Professor & Head of the Department of Civil and Environmental Engineering at the National University of Singapore, specializing in steel-concrete composite structures and resilient infrastructure systems',
  //   photo: ProfRichardLiew,
  //   affiliationUrl: 'https://cde.nus.edu.sg/cee/staff/liew-jat-yuen-richard/'
  // },
    {
    name: 'Prof Ben Young',
    affiliation: 'The Hong Kong Polytechnic University',
    bio: 'Vice President (Student and Global Affairs) and Chair Professor of Steel Structures at The Hong Kong Polytechnic University, specializing in cold-formed steel, stainless steel, and structural stability',
    photo: ProfBenYoung,
    affiliationUrl: 'https://www.polyu.edu.hk/ppoffice/senior-management-team/vpsga/'
  },
  {
    name: 'Prof Tuan Ngo',
    affiliation: 'University of Melbourne',
    bio: 'Professor at the University of Melbourne and Research Program Leader of Building 4.0 CRC, specializing in prefabricated modular buildings, composite materials, and sustainable construction technologies',
    photo: ProfTuanNgo,
    affiliationUrl: 'https://findanexpert.unimelb.edu.au/profile/6717-tuan-ngo'
  },
  {
    name: 'Prof Sarah (Yixia) Zhang',
    affiliation: 'University of Technology Sydney',
    bio: 'Professor & Head of the School of Mechanical and Mechatronic Engineering at the University of Technology Sydney, specializing in advanced materials, composite structures, and manufacturing technologies',
    photo: ProfSarahYixiaZhang,
    affiliationUrl: 'https://profiles.uts.edu.au/Sarah.Zhang'
  },
  // {
  //   name: 'Prof Heng Hu',
  //   affiliation: 'Wuhan University',
  //   bio: 'Head of Department at Wuhan University, specializing in data-driven computational mechanics and composite structures',
  //   photo: ProfHengHu,
  //   affiliationUrl: 'https://www.researchgate.net/profile/Heng-Hu-10'
  // },
  {
    name: 'Prof Halil Sezen',
    affiliation: 'Ohio State University',
    bio: 'Professor of Structural Engineering at The Ohio State University, specializing in seismic performance and collapse prevention of reinforced concrete buildings. Fellow of ACI, SEI, and ASCE, and Editor-in-Chief of the Journal of Building Engineering (Elsevier). His research focuses on improving structural resilience through ductile design and detailing for collapse mitigation',
    photo: ProfHalilSezen,
    affiliationUrl: 'https://ceg.osu.edu/people/sezen.1'
  },
  {
    name: 'Distinguished Prof Vivian W. Y. Tam',
    affiliation: 'Western Sydney University',
    bio: 'Distinguished Professor and Director of the ARC Industrial Transformation Training Centre in Digital Platforms for Net-Zero Building Ecosystem Lifecycle (NØBEL) at Western Sydney University, specializing in construction engineering and management, green buildings, and recycled concrete. Fellow of the Australian Academy of Technological Sciences and Engineering (ATSE) and Editor-in-Chief of the International Journal of Construction Management. Winner of the 2025 NSW Premier’s Prize for Excellence in Engineering or Information and Communication Technologies',
    photo: ProfVivianTam,
    affiliationUrl: 'https://researchers.westernsydney.edu.au/en/persons/vivian-tam/'
  }
];

const KeynoteSpeakersPage = () => {
  return (
    <section className="speakers-page fade-in-up">
      <div className="container-large">
        <h1 className="speakers-heading">Keynote Speakers</h1>
        <div className="speakers-grid">
          {keynoteSpeakers.map((spk, idx) => (
            <SpeakerCard key={spk.name} speaker={spk} style={{ animationDelay: `${idx * 0.1}s` }} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default KeynoteSpeakersPage;
